import React from 'react';

import { RoleEmployee, RoleUser } from '@homesusa/core';
import { AuthCompanyContext, useAuth } from '../providers';

export const useHasRole = (): {
  hasEmployeeRole: (roles: RoleEmployee[]) => boolean;
  hasUserRole: (roles: RoleUser[]) => boolean;
  isMlsAdministrator: boolean;
  isLoading: () => boolean;
} => {
  const { currentEmployee } = React.useContext(AuthCompanyContext);
  const { user: userProfile } = useAuth();

  const hasUserRole = React.useCallback(
    (roles: RoleUser[]): boolean => {
      // is mls admin has an employee role asigned must be treated as a company user
      const userRole =
        userProfile?.role == RoleUser.MLSAdministrator && currentEmployee != null
          ? RoleUser.User
          : userProfile?.role;
      return !!userRole && roles.includes(userRole);
    },
    [userProfile?.role]
  );

  const isMlsAdministrator = React.useMemo(
    // mls admin must not have an employee role assigned
    () => userProfile?.role == RoleUser.MLSAdministrator && currentEmployee == null,
    [userProfile?.role]
  );

  const hasEmployeeRole = React.useCallback(
    (roles: RoleEmployee[]): boolean => {
      return !!roles && !!currentEmployee && roles.includes(currentEmployee.roleName);
    },
    [currentEmployee]
  );

  const isLoading = React.useCallback((): boolean => {
    return !userProfile || (hasUserRole([RoleUser.User]) && !currentEmployee);
  }, [userProfile, hasUserRole, currentEmployee]);

  return { hasEmployeeRole, hasUserRole, isMlsAdministrator, isLoading };
};
